module.exports = require("!!vue-loader!../../node_modules/v-markdown-loader/_cache/vux-build-issue-22.vue");


//////////////////
// WEBPACK FOOTER
// ./en/faq/vux-build-issue.md
// module id = 592
// module chunks = 211